/***
 * File name: forms.js
 *
 * Program Description:
 * This file contains all the meta data of the generic forms in the system
 *
 */
const forms = {
  signup: {
    title: 'New Freshman Signup Form',
    section1: {
      title: 'Basic Information'
    },
    section2: {
      title: 'Address'
    },
    section3: {
      title: 'Authentication'
    }
  },
  passReset: {
    title: 'Request Password Reset',
    button: 'Submit',
    tooltip: 'A password reset link will be sent to the email provided',
    success: 'Please check your email address to reset your password.'
  },
  changePass: {
    title: 'Change Password',
    button: 'Submit',
    tooltip: 'Change your login password by entering your old password and a new password.'
  }
}
export default forms
